import React from 'react'
import { makeStyles } from '@material-ui/core/styles'

import { ReactComponent as LogoIcon } from '../../assets/img/404.svg'

import { Link } from 'react-router-dom'
import { Grid, Container, Button } from '@material-ui/core'

import styles from 'assets/jss/material-kit-react/views/notFoundPage.js'

const useStyles = makeStyles(styles)

export default function NotFoundPage() {
  const classes = useStyles()

  return (
    <Container className={classes.container}>
      <Grid container direction="row" justify="center" alignItems="center">
        <Grid item md={6}>
          <LogoIcon />
        </Grid>
        <Grid item md={6}>
          <h1>404</h1>
          <h2>UH OH! 页面丢失</h2>
          <p>您所寻找的页面不存在。你可以点击下面的按钮，返回主页。</p>
          <Link to="/">
            <Button variant="contained" color="primary">
              返回首页
            </Button>
          </Link>
        </Grid>
      </Grid>
    </Container>
  )
}
